// @flow
import React, { Component } from 'react';
import * as Cookie from 'app/packages/cookie-utils';
import CONST from 'app/common/lib/Const';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import { loggingSettings } from 'app/common/react/components/growth/unauth/PageContext';
import { track } from 'app/common/lib/react/analytics';
import { EUCookieBarShown, EUCookieBarHide } from 'app/www-unauth/redux/actions/euCookieBarActions';

export const EU_COOKIE_BAR_HEIGHT = 36;

const styles = {
  outerBar: {
    backgroundColor: '#1c232c',
    boxSizing: 'border-box',
    textAlign: 'center',
    width: '100%',
    padding: '6px 20px',
    position: 'fixed',
    top: '0px',
    zIndex: '700', // must be larger than the z-index of UnauthHeader
  },
  outerBarMobile: {
    textAlign: 'left',
    backgroundColor: '#364A4C',
    padding: '14px 20px',
    lineHeight: '18px',
  },
  cookieText: {
    color: '#b9b9b9',
    display: 'inline',
    opacity: '.85',
  },
  learnMore: {
    color: '#fff',
    display: 'inline',
  },
  cookieButton: {
    backgroundColor: 'transparent',
    borderRadius: '3px',
    color: '#fff',
    display: 'inline',
    padding: '3px 10px',
    border: 'none',
    margin: '0 0 0 4px',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '18px',
    verticalAlign: 'baseline',
  },
  cookieButtonMobile: {
    padding: '3px 2px',
  },
};

type Props = {
  dispatch: Function,
  pageType: string,
};

type State = {
  showCookieBanner: boolean,
};

type Context = {
  cookies: Object,
  country: string,
  isAuthenticated: boolean,
  userAgent: {
    isMobile: boolean,
  },
};

class EuCookieBar extends Component<Props, State> {
  constructor(props: Props, context: Context) {
    super(props, context);
    const euCountries = CONST.GEN.templateConst.settings.EU_COUNTRIES;
    let showCookieBanner = false;
    if (
      !this.context.isAuthenticated &&
      euCountries.indexOf(context.country) > -1 &&
      !context.cookies[PCONST.CookieName.SUPPRESS_EU_COOKIE_BANNER]
    ) {
      showCookieBanner = true;
      const { dispatch } = this.props;
      dispatch(EUCookieBarShown());

      this.loggingData = loggingSettings(this.props.pageType);
    }

    this.state = { showCookieBanner };
  }

  componentDidMount() {
    trackRegisterAction('unauth_eu_cookie_banner_view');
    if (this.loggingData) {
      track(PCONST.thrift.EventType.VIEW, {
        view: this.loggingData.viewType,
        viewParameter: this.loggingData.viewParameter,
        component: PCONST.thrift.ComponentType.COOKIE_POLICY_BANNER,
      });
    }
  }

  loggingData: Object;

  handleGotItClick = (e: SyntheticEvent<>) => {
    Cookie.set(PCONST.CookieName.SUPPRESS_EU_COOKIE_BANNER, 'true');
    this.setState({ showCookieBanner: false });
    this.props.dispatch(EUCookieBarHide());

    trackRegisterAction('unauth_eu_cookie_banner_dismissed');

    if (this.loggingData) {
      track(PCONST.thrift.EventType.CLICK, {
        view: this.loggingData.viewType,
        viewParameter: this.loggingData.viewParameter,
        component: PCONST.thrift.ComponentType.COOKIE_POLICY_BANNER,
        element: PCONST.thrift.ElementType.ACCEPT_BUTTON,
      });
    }
  };

  handleLearnMoreClick(e: SyntheticEvent<>) {
    trackRegisterAction('unauth_eu_cookie_banner_learnmore');
  }

  render() {
    let outerBarStyles = styles.outerBar;
    const cookieTextStyles = styles.cookieText;
    let cookieButtonStyles = styles.cookieButton;
    if (this.context.userAgent.isMobile) {
      outerBarStyles = { ...outerBarStyles, ...styles.outerBarMobile };
      cookieButtonStyles = { ...cookieButtonStyles, ...styles.cookieButtonMobile };
    }
    const cookieTextOne = i18n._(
      'Pinterest is ',
      "The full text is 'Pinterest is using cookies to help give you the best " +
        "experience we can.' and is part of eu cookie banner",
    );
    const cookieTextTwo = i18n._(
      'using cookies',
      "The full text is 'Pinterest is using cookies to help give you the best " +
        "experience we can.' and is part of eu cookie banner",
    );
    const cookieTextThree = i18n._(
      ' to help give you the best experience we can.',
      "The full text is 'Pinterest is using cookies to help give you the best " +
        "experience we can.' and is part of eu cookie banner",
    );

    if (this.state.showCookieBanner) {
      return (
        <div className="outerCookieBar" style={outerBarStyles} data-test-id="unauthEuCookieBar">
          <p style={cookieTextStyles}>{cookieTextOne}</p>
          <a
            className="EuCookieBar__learnMore"
            href={CONST.GEN.templateConst.settings.ABOUT_COOKIE_URL}
            onClick={this.handleLearnMoreClick}
            style={styles.learnMore}
            target="_blank"
          >
            {cookieTextTwo}
          </a>
          <p style={cookieTextStyles}>{cookieTextThree}</p>
          <button
            className="EuCookieBar__cookieButton"
            onClick={this.handleGotItClick}
            style={cookieButtonStyles}
            tabIndex="0"
            data-test-id="unauthEuCookieBar_gotItButton"
          >
            {i18n._('Got it!')}
          </button>
        </div>
      );
    } else {
      return null;
    }
  }
}

EuCookieBar.contextTypes = {
  cookies: PropTypes.object.isRequired,
  country: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  userAgent: PropTypes.shape({
    isMobile: PropTypes.bool.isRequired,
  }).isRequired,
};

export default EuCookieBar;
